<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="$t('settings.title')"></page-header-title>

      <v-spacer></v-spacer>

      <action-button type="save" @click="save" />
    </v-app-bar>

    <v-card>
      <v-card-text class="pa-2">
        <v-form ref="form">
          <v-flex md12>
            <v-simple-table>
              <template v-slot:default>
                <tbody>
                  <tr class="border-bottom">
                    <td scope="row" width="30%">{{ $t("settings.locale") }}</td>
                    <td>
                      <v-select
                        name="settings.locale"
                        v-model="s_locale"
                        class="required-field"
                        v-validate="'required'"
                        item-text="text"
                        item-value="key"
                        :items="$dd_locales()"
                        :menu-props="settings.locale"
                        :error-messages="errors.collect('setting.locale')"
                        clearable
                      ></v-select>
                    </td>
                  </tr>
                  <tr class="border-bottom">
                    <td scope="row" width="30%">{{ $t("settings.rows_per_page") }}</td>
                    <td>
                      <v-select
                        name="settings.rows_per_page"
                        v-model="s_rows_per_page"
                        class="required-field"
                        v-validate="'required'"
                        :items="DATATABLE_ITEM_PER_PAGE_OPTIONS"
                        :error-messages="errors.collect('setting.rows_per_page')"
                      ></v-select>
                    </td>
                  </tr>
                  <tr class="border-bottom">
                    <td scope="row" width="30%">{{ $t("settings.pin_title") }}</td>
                    <td>
                      <v-btn class="mt-4 darken-2" color="primary" @click="showPincode">{{ $t("settings.change_pin_title") }}</v-btn>

                      <v-chip class="ma-2 mt-6" color="warning" outlined v-if="!has_pincode" small>
                        {{ $t("settings.pin_not_set") }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-form>
      </v-card-text>
    </v-card>

    <pinCode
      :key="reRenderPinCode"
      :show="show_pincode"
      :verify_currentpin="true"
      @callback_pincode_submit="callback_pincode_submit"
      @callback_pincode_cancel="show_pincode = false"
    />
  </v-container>
</template>

<script>
import pinCode from "@/modules/auth/partials/PinCode"

export default {
  name: "settings",

  components: {
    pinCode
  },

  data() {
    return {
      user: {},
      predata: {},
      settings: {},

      s_locale_old: null,
      s_locale: null,
      s_rows_per_page: null,

      has_pincode: false,
      show_pincode: false,
      reRenderPinCode: 0,

      dictionary: {
        attributes: {
          "setting.locale": this.$t("settings.locale"),
          "setting.rows_per_page": this.$t("settings.rows_per_page")
        }
      }
    }
  },

  beforeRouteLeave(to, from, next) {
    this.$validator.validateAll().then(() => {
      this.$leaveFormConfirmation(next, this.settings, this.predata, this.save, this.isFormValid)
    })
  },

  created() {
    let user = localStorage.getItem("__crrntUser")
    this.user = JSON.parse(user)

    axios
      .get(this.API_URL + "setting/" + this.user.id)
      .then((res) => {
        if (res.data.data) {
          this.settings = res.data.data

          this.init()

          // JSON stringify and parse to remove variable reactiveness
          this.predata = JSON.parse(JSON.stringify(this.settings))

          this.checkIfHasPincode()
        }
      })
      .catch((err) => console.log(err))
  },

  mounted() {
    this.$validator.localize(this.$getSetting("locale"), this.dictionary)
  },

  computed: {
    isFormValid() {
      return !Object.keys(this.fields).some((key) => this.fields[key].invalid)
    }
  },

  methods: {
    init() {
      this.s_locale = this.settings.find((i) => i.key == "locale").value
      this.s_locale_old = JSON.parse(JSON.stringify(this.s_locale)) // Save old locale to check if it is changed

      this.s_rows_per_page = Number(this.settings.find((i) => i.key == "rows_per_page").value)
    },
    save() {
      this.$validator.validate()

      this.$validator
        .validateAll()
        .then(() => {
          if (this.isFormValid) {
            let vm = this

            let data = []
            data.push({ key: "locale", value: this.s_locale })
            data.push({ key: "rows_per_page", value: this.s_rows_per_page })

            axios
              .post(this.API_URL + "setting", {
                user_id: this.user.id,
                data: JSON.stringify(data)
              })
              .then((res) => {
                if (res.data.data) {
                  vm.settings = res.data.data
                  vm.predata = JSON.parse(JSON.stringify(vm.settings))

                  vm.$updateSetting("locale", this.s_locale)
                  vm.$updateSetting("rows_per_page", this.s_rows_per_page)

                  vm.$store.dispatch("auth/updateUserState", vm)

                  if (this.s_locale != this.s_locale_old) {
                    vm.$i18n.locale = vm.s_locale
                    vm.$updateSetting("locale", vm.s_locale)
                  }

                  vm.init()
                  vm.$awn.success(vm.$t("global.setting_updated_success"))
                }
              })
              .catch((err) => console.log(err))
          } else {
            this.$awn.alert(this.$t("global.form_not_valid"))
          }
        })
        .catch(() => {})
    },
    showPincode() {
      this.reRenderPinCode += 1
      this.show_pincode = true
    },
    checkIfHasPincode() {
      this.$store.dispatch("auth/hasPinCode").then((result) => {
        this.has_pincode = result
      })
    },
    callback_pincode_submit(pin) {
      this.show_pincode = false
      this.$store.dispatch("auth/setPinCode", {
        pin: pin,
        userid: this.user.id,
        login_via_pin: true
      })

      this.has_pincode = true
    },
    callback_pincode_cancel() {
      this.id = null
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
